// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"4f675bcb","234":"73dbb911"}[chunkId] + ".js";
};